export default __webpack_public_path__ + "assets/webgl/complete-3.6d51ca04.jpg";